import * as Sentry from '@sentry/react';
import * as React from 'react';
import { RootContext } from '../contexts/root';
import { useEnv } from '../hooks/env';
import { log } from '../utils/log';

export const ErrorMonitoring: React.FC = React.memo(({ children }) => {
  const { appName, appVersion } = React.useContext(RootContext);
  const { getEnv } = useEnv();

  React.useEffect(() => {
    log('Error Monitoring', 'Inicialização do Sentry');
    getEnv('sentry')
      .catch(() =>
        log('Error Monitoring', '⚠️ Não achou a variável "sentry" no env.json'),
      )
      .then((sentryConfig) =>
        Sentry.init({
          release: `${appName}@${appVersion}`,
          ...(sentryConfig as Sentry.BrowserOptions),
        }),
      );
  }, []);

  return <>{children}</>;
});

ErrorMonitoring.displayName = 'SebraeErrorMonitoring';
